
import {Throttle} from "@/api/api";

type screen = {
	search: string;
	time: Array<string> | null;
	service: Array<number> | null;
};
type parts = {
    code: string;
    date: string;
    time: string;
    status_text: string;
    type: string;
    relation: string;
    purchase: string;
    supplier: string;
    desc: string;
    cost_price: number | null;
    price: number | null;
    number: number;
    id?: number;
};

const columnList: Array<column> = [
    {
        prop: "purchase_time_text",
        label: "单据日期",
        width: 75,
    },
    {
        prop: "create_time_text",
        label: "制单时间",
        width: 75,
    },
    {
        prop: "toexamine",
        label: "状态",
        width: 75,
    },
    {
        prop: "purchase_type_name",
        label: "采购类型",
        width: 75,
    },
    {
        prop: "purchaes_bill",
        label: "关联单据",
        width: 75,
    },
    {
        prop: "employee",
        label: "采购员",
        width: 75,
    },
    {
        prop: "supplier",
        label: "供应商",
        width: 75,
    },
    {
        prop: "purchase_desc",
        label: "备注",
        width: 75,
    },
    {
        prop: "total_price",
        label: "采购金额",
        width: 75,
    },
    {
        prop: "number",
        label: "数量",
        width: 75,
    },
];

const purchaseColumn: Array<column> = [
    {
        prop: "name",
        label: "配件名称",
        width: 120,
    },
    {
        prop: "specification",
        label: "规格",
        width: 120,
    },
    {
        prop: "encoding",
        label: "编码",
        width: 80,
    },
    {
        prop: "mountings_type_p_name",
        label: "配件分类",
        width: 80,
    },
    {
        prop: "mountings_brand_name",
        label: "品牌",
        width: 80,
    },
    {
        prop: "mountings_unit_name",
        label: "单位",
        width: 80,
    },
    {
        prop: "cost_price",
        label: "采购单价",
        width: 80,
    },
    {
        prop: "member",
        label: "数量",
        width: 80,
    },
    {
        prop: "total_price",
        label: "金额",
        width: 80,
    },
];
import {
	defineComponent,
	ref,
	reactive,
	inject,
	provide,
	onMounted,
	watch
} from "vue";
import {Request} from '@/api/request';
import {
    getPurchaseTable,
    getPurchaseInfo,
    getSupplierTotalList,
    getAdminList,
    toExamine,
    purchaseToVoid,
    purchaseRecovery, permissionList, purchaseInfoUpdate
} from "@/api/http";
import {column} from "@/assets/types/common";
import editList from "@/components/editlist/editlist.vue";
import { useRoute, useRouter } from 'vue-router'


export default defineComponent({
    name: "PurchaseManagement",
	components: { editList },
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["采购管理"]);
        //修改功能
        let editCarData = reactive({
            dialog_show: false,
            rules: {},
            form: {
                purchase_date: 0
            },
            select_purchase_id:0,
            formRef: null,
        });
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            purchaseDetail = ref([] as any),
            loading = ref(true),
			isPrint = ref(false),
			isMountings = ref(false),
            dialogFormVisible = ref(false),
            roleList = ref({} as any),
            detailTable = ref([] as Array<any>),
			headClass = inject("headClass"),
			Router = useRouter(),
            total = ref(0),
            
			screenParameter = reactive({
				page: 1,
				pagesize: 10,
				time_type: '',
				start_time: '',
				end_time: '',
				purchase_type: '',
				status: '',
				supplier_id: '',
				employee_id: '',
				search: ''
			 
			}),
			screen = ref({
			    search: "",
			    time: null,
			    service: null,
			} as screen),
			dialog_show = ref({
				commonly: false,
				existing: false,
				return: false
			} as any),
			supplierList = ref([] as Array<parts>),
			adminList = ref([] as Array<any>),
            // 打印的表单
            printData = {
                id: "#print",
                popTitle: "车辆维修工时配件报价单",
                startCallback() {
                },
            },
            saveSubmit = (() => {
                editCarData.form.purchase_date = new Date(editCarData.form.purchase_date).getTime() / 1000;
                let data = {
                    purchase_id:editCarData.select_purchase_id,
                    purchase_date:editCarData.form.purchase_date
                };
                purchaseInfoUpdate(data).then(()=>{
                    editCarData.dialog_show = false;
                    getTableData();
                });
            }),
            getSummaries = (param: any, type: number): Array<string> => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "total_price",
                    "member",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
						// 增加合计项
                        switch (type) {
							// 配件合计
                            case 1:
                                if (column.property == "total_price") {
                                    sums[index] = purchaseDetail.value.total_price;
                                } else {
                                    sums[index] = purchaseDetail.value.number;
                                }
                                break;
                        }
						if(column.property == "member"){
							sums[index] = `${sums[index]}`;
						}else{
							sums[index] = `¥${sums[index]}`;
						}
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            // 点击单据编号触发
            bindPurchaseInfo = (purchase_id: number) => {
                getPurchaseInfo({ purchase_id }).then((res: any) => {
                    if (res.status == 200) {
						let info = res.content.list;
						if(info) {
							let arr = [[
								'单据编号',
								info.purchaes_number,
								'状态',
								info.toexamine,
								'单据日期',
								info.purchase_time_text,
								'供应商',
								info.supplier,
							],[
								'制单时间',
								info.create_time_text,
								'制单人',
								info.preparer_text,
								'审核时间',
								info.toexamine_time_text,
								'审核人',
								info.reviewer_text,
							],[
								'采购员',
								info.employee_text,
								'采购类型',
								info.purchase_type_name,
								'关联单据',
								info.purchaes_bill,
								'实际采购单号',
								info.purchase_sh,
							],[
								'备注',
								info.purchase_desc,
							]];
							detailTable.value = arr;
							purchaseDetail.value = res.content.list;
							dialogFormVisible.value = true;
							if(res.content.list.data.length > 0){
								isMountings.value = true
							}
						}
                    }
                });
            },
			// 触发打印
            bindPrint = (data: any): void => {
				getPurchaseInfo({ purchase_id:data.purchase_id }).then((res: any) => {
					if (res.status == 200) {
						if(res.content.list) {
							purchaseDetail.value = res.content.list;
							document.getElementById("printBtn")!.click();
							isPrint.value = true;
							setTimeout(() => {
								isPrint.value = false;
								console.log(isPrint.value)
							},1)
						}
					}
				});
            },
			
            getTableData = (): void => {
                loading.value = true;
                let mydata = {
                    type:1,
                    role_name:'purchase_management',
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                getPurchaseTable({...screenParameter}).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                  total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (size: number): void => {
            screenParameter.pagesize = size;
              getTableData();
            },
            handleCurrentChange = (page: number): void => {
              screenParameter.page = page;
              getTableData();
            },
			getsupplierList = (): void => {
				loading.value = true
				getSupplierTotalList({status:1}).then((res: any) => {
					supplierList.value = res?.content?.list || [];
				})
			},
            buttonClick = (index:number,purchase_id:number,purchase_type:number)=> {
                switch (index){
                    case 1:{//作废
                        purchaseToVoid({purchase_id}).then(()=>{
                            getTableData();
                        });
                    }
                    break;
                    case 2:{//恢复
                        purchaseRecovery({purchase_id}).then(()=>{
                            getTableData();
                        });
                    }
                        break;
                    case 3:{//修改
                        if (purchase_type == 2){//修改既用件
                            _option('/purchase/readyUseParts', {type: 'existing', id: purchase_id});
                        } else if (purchase_type == 3){//修改采购退货
                            _option('/purchase/editReturnGoods', {type: 'existing', id: purchase_id});
                        } else {
                            _option('/purchase/commonParts', {type: 'commonly', id: purchase_id});
                        }
                        
                    }
                        break;
                    case 6:{//信息编辑
                        editCarData.form.purchase_date = 0;
                        editCarData.dialog_show = true;
                        editCarData.select_purchase_id = purchase_id;
                    }
                        break;
                }
                
            },
            //格式化列显示内容，采购退货的金额和数量前端手动加上“-”号
            getText = (row:any,column:any,cellValue:any,index:number):string => {
                if (column.property == 'total_price' || column.property == 'number'){
                    if (row.purchase_type == 3){
                        return '-' + cellValue;
                    }else {
                        return cellValue;
                    }
                    
                } else {
                    return cellValue;
                }
                
            },
			getadminlist = (): void => {
				loading.value = true
				getAdminList({}).then((res: any) => {
					adminList.value = res?.content?.list || [];
				})
				
			},
			selectChange = (e: number): void => {
			    getTableData();
			},
			searchChange = (e:string) => {
				getTableData();
			},
            _toexamine = new Throttle().use((id: number|string ): void => {
                loading.value = true;
                toExamine({purchase_id:  id}).then((res: any) => {
                    getTableData();
                })
            },1500),
			// _toexamine = (id: number|string ): void => {
			// 	if(!confirm("是否确认？")) return
			// 	loading.value = true;
			// 	toExamine({purchase_id:  id}).then((res: any) => {
			// 		getTableData();
			// 	})
			// },
			screenChange = (
			    e: string | Array<Date> | Array<number>,
			    key: string
			): void => {
			    if (!e) {
                    screenParameter.start_time = '';
                    screenParameter.end_time = '';
			    } else {
                    screenParameter.start_time =
                        ((e[0] as Date).getTime() / 1000).toString();
                    screenParameter.end_time =
                        ((e[1] as Date).getTime() / 1000).toString();
			    }
			    getTableData();
			},
			_option = (url: string , data: any) => {
				Router.push({
					path: url,
					query: data
				})
			}
			
        onMounted(() => {
			getTableData()
			getsupplierList();
			getadminlist();
        });
		
		
        return {
            columnList,
            tableData,
            loading,
			purchaseDetail,
			printData,
			bindPrint,
			isPrint,
			isMountings,
			detailTable,
			getSummaries,
			dialogFormVisible,
			getsupplierList,
			supplierList,
			dialog_show,
			headClass,
			screen,
			screenChange,
			screenParameter,
			selectChange,
			getadminlist,
			adminList,
			_toexamine,
			_option,
			bindPurchaseInfo,
			purchaseColumn,
			searchChange,
          handleSizeChange,
          handleCurrentChange,
            editCarData,
          total,
            buttonClick,
            getText,
            saveSubmit,
            currentPage,
            pageSize,
            roleList
        };
    },
});
